import NoDataComponent from '@Components/General/Feedback/no-data-component';
import {
    AddCircleOutlineRounded,
    FileUploadOutlined,
    Groups2Rounded,
} from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import useContactsUpload from '../Contacts/useContactsUpload';

const NoContacts = () => {
    const { t } = useTranslation();

    const handleContactsUpload = useContactsUpload();

    return (
        <NoDataComponent
            primary={t('prompts:noData.contacts.noContacts.primary')}
            secondary={t('prompts:noData.contacts.noContacts.secondary')}
            Icon={Groups2Rounded}
            action={
                <Stack spacing={1}>
                    <Button
                        startIcon={<AddCircleOutlineRounded />}
                        LinkComponent={Link}
                        to="new/edit"
                    >
                        {t('Create Contact')}
                    </Button>
                    <Button
                        startIcon={<FileUploadOutlined />}
                        variant="tonal"
                        onClick={handleContactsUpload}
                    >
                        {t('Upload Contacts')}
                    </Button>
                    <Typography variant="bodySmall" color="InactiveCaptionText">
                        {t('Supports CSV and Excel files')}
                    </Typography>
                </Stack>
            }
        />
    );
};

export default NoContacts;
